export const MenuConstants = {
    ManageCompanyProfile: "Manage Company Profile",
    CustomFields: "Custom Fields",
    NoteTemplates: "Note Templates",
    Settings: "Settings",
    ManageRelationships: "Manage Relationships",
    ManageUsers: "Manage Users",
    RuleSet: "Rule Set",
    AccessToCommunities: "Access To Communities",
    RuleEngine: "Rule Engine",
    Party: "Party",
    ManageTemplate: "Manage Template",
    ManageInbox: "Manage Inbox",
}